module.exports = __webpack_public_path__ + "static/media/municipal tax _ services.e7505ce6.png";